module.exports = __webpack_public_path__ + "static/media/cotton-icon.5435155c.svg";